import type { FunctionComponent } from 'react'
import React from 'react'

import { ClockIcon } from '../../../Icons/Miscellaneous/Clock'
import { TypographyV2 } from '../../Foundations/Typography'
import styles from './ReadingTime.module.scss'

export const ReadingTime: FunctionComponent<ReadingTimeProps> = ({
  readTime,
  text = 'min read',
}) => {
  if (!readTime) {
    return null
  }

  const Icon = ClockIcon

  return (
    <div className={styles.readingTime}>
      <Icon className={styles.readingTimeIcon} data-testid="reading-time-icon" />
      <TypographyV2
        dataTestId="reading-time-text"
        textStyle="sb-text-interface-body-x-small-regular"
        tag="span"
      >
        {readTime} {text}
      </TypographyV2>
    </div>
  )
}

export type ReadingTimeProps = {
  /**
   * Read time String
   */
  readTime: string
  /**
   * Text String
   */
  text?: string
}
